import React from 'react';
import { calculateEtaForSku } from '~/src/utils/calculateEtaForSku';
import { useStore } from '~/src/hooks/useStore';
import ClockFilledIcon from '~/public/bb2assets/svg/ClockFilledIcon.svg';
import ExpressIcon from '~/public/bb2assets/svg/ExpressIcon.svg';

function EtaVariants({ availability, sa_id }) {
  const appHeader = useStore((state) => state.appHeader);
  const eta = calculateEtaForSku(sa_id, appHeader?.sa_list);
  if (availability?.avail_status !== '001' || !eta) return null;

  return availability?.show_express ? (
    <div className="flex items-center bg-silverSurfer-100 rounded-s p-1 space-x-1">
      <ExpressIcon width="10px" height="10px" />
      <div className="text-slimyGreen-800 text-sm font-semibold leading-[13px] truncate uppercase">{eta}</div>
    </div>
  ) : (
    <div className="flex items-center bg-sunglow-100 rounded-s p-1 space-x-1">
      <ClockFilledIcon width="10px" height="10px" />
      <div className="text-sunglow-800 text-sm font-semibold leading-[13px] truncate uppercase">{eta}</div>
    </div>
  );
}

export default EtaVariants;
